export default "__VITE_ASSET__gR6ZOfjo__"